import { AxiosError } from 'axios';
import { useRouter } from 'next/router';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { iteroCheckoutService } from 'services';
import { Cart, IOrder, PlaceITeroOrderParams } from 'types';

export const usePlaceIteroOrder = () => {
  const queryClient = useQueryClient();
  const router = useRouter();
  return useMutation(
    ({
      selectedProposalId,
      selectedShippingAddress,
      selectedBillingAddress,
      selectedScannerSubFundingSource,
      selectedScannerPaymentCreditCard,
      selectedSubscriptionPaymentCreditCard,
      selectedRentalPaymentCreditCard,
      additionalOrderInfo,
      setOrderFailureMessage,
      ipAddress,
      pcUsername,
      base64Stringpdf,
    }: PlaceITeroOrderParams) => {
      return iteroCheckoutService.placeIteroOrder(
        selectedProposalId,
        selectedShippingAddress,
        selectedBillingAddress,
        selectedScannerSubFundingSource,
        selectedScannerPaymentCreditCard,
        selectedSubscriptionPaymentCreditCard,
        selectedRentalPaymentCreditCard,
        additionalOrderInfo,
        ipAddress,
        pcUsername,
        base64Stringpdf
      );
    },
    {
      onSuccess: (data, variables, context) => {
        console.log('data in hook', data);
        variables.setOrderStep('complete');

        router.push(
          `/iteroscanners/orderdetails/${data.data.proposal}?checkoutState=complete`
        );
        queryClient.invalidateQueries([
          ServerStateKeysEnum.approvedIteroProposalDetails,
        ]);
        queryClient.invalidateQueries([ServerStateKeysEnum.iteroorderHistory]);
      },
      onError: (error: AxiosError, variables, context) => {
        variables.setOrderStep('failed');
      },
    }
  );
};
